<template>
  <v-container fluid class="pa-0 aru-calendar-list">
    <v-layout row>
      <v-flex>
        <v-date-picker
          @click.native="clickOnPicker($event)"
          full-width
          v-model="date"
          id="aru-calendar-list-picker"
          :picker-date.sync="pickerDate"
          :events="dayColors"
          color="primary"
          event-color="green lighten-1"
          locale="es-es"
        ></v-date-picker>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-toolbar v-if="showTitle || actionButton" color="transparent" dense flat>
            <v-toolbar-title>
              <h6 v-if="showTitle" class="headline">{{ $t(title) }}</h6>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                @click="$emit('actionButtonClicked')"
                color="primary"
                class="text-capitalize"
                v-if="actionButton"
                flat
              >
                <v-icon class="mr-2">mdi-calendar-clock</v-icon>
                {{ $t(actionButtonText) }}
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text class="px-0 py-0">
            <v-list
              :expand="expanded"
              v-if="collapsible"
              class="scroll-y"
              style="max-height: 40vh;"
              overflow-hidden
            >
              <v-list-group :value="expanded" v-for="(events, day) in eventsDate" :key="day">
                <!-- <v-subheader slot="activator">
                                    {{day | moment(displayDateFormat)}}
                </v-subheader>-->

                <v-list-tile slot="activator" class="aru-calendar-list-group-activator">
                  <v-list-tile-action>
                    <v-icon size="20" color="grey">mdi-calendar-blank</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title class="body-2 grey--text">
                      {{ day | moment(displayDateFormat) }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  v-for="(myEvent, i) in events"
                  :key="i"
                  @click="$emit('eventItemClicked', myEvent)"
                >
                  <v-list-tile-action>
                    <v-icon :color="getFieldEventColor(myEvent)">mdi-circle-medium</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <span>
                      {{ myEvent[eventDisplayField] | truncate(40, '...') }}
                    </span>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-tooltip left>
                      <aru-status-icon
                        slot="activator"
                        entity="calendarEvent"
                        :status="myEvent[eventDisplayStatusField]"
                      ></aru-status-icon>
                      <span>{{ $t(myEvent[eventDisplayStatusField]) }}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list-group>
            </v-list>
            <v-list v-else subheader dense class="aru-calendar-list-events">
              <template v-for="(events, day, index) in eventsDate">
                <v-subheader :key="day" :class="'subheader-' + index">
                  <v-icon small>mdi-calendar-blank</v-icon>
                  {{ day | moment(displayDateFormat) }}
                </v-subheader>
                <v-list-tile v-for="(myEvent, i) in events" :key="i">
                  <v-icon :color="getFieldEventColor(myEvent)">mdi-circle-medium</v-icon>
                  {{ myEvent[eventDisplayField] }}
                </v-list-tile>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const moment = require('moment');
require('moment/locale/es');

import AruDateListMixin from '@/mixins/list/AruDateListMixin.js';
import AruStatusIcon from '@/components/commons/AruStatusIcon.vue';
export default {
  components: {
    AruStatusIcon,
  },
  mixins: [AruDateListMixin],
  props: {
    value: {
      type: [String, Object],
    },
    dateField: {
      type: String,
      default: 'date',
    },
    eventTypeField: {
      type: String,
      default: 'category',
    },
    eventTypeColors: {
      type: Object,
      default() {
        return {};
      },
    },
    eventDefaultColor: {
      type: String,
      default: 'primary',
    },
    eventDisplayField: {
      type: String,
      default: 'name',
    },
    eventDisplayStatusField: {
      type: String,
      default: 'status',
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Eventos',
    },
    displayDateFormat: {
      type: String,
      default: 'DD/MM/YYYY',
    },
    row: {
      type: Boolean,
      default: false,
    },
    collapsible: {
      type: Boolean,
      default: true,
    },
    actionButton: {
      type: Boolean,
      default: false,
    },
    actionButtonText: {
      type: String,
      default: 'Pedir cita',
    },
  },
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      pickerDate: null,
    };
  },
  computed: {
    expanded() {
      if (this.readyToList) {
        return this.items.length < 5;
      } else {
        return false;
      }
    },
    eventDateAndDayColors() {
      let events = {};
      let dayColors = {};
      // events = {
      //     '2019-02-25': {colors: ['primary', 'secundary'], events,
      //     '2019-02-24': ['success', 'error']
      // }

      // return events;
      if (this.readyToList) {
        this.items.forEach(element => {
          if (this.dateField && element.hasOwnProperty(this.dateField)) {
            let elementDate = moment(element[this.dateField]).format('YYYY-MM-DD');
            if (!dayColors.hasOwnProperty(elementDate)) {
              dayColors[elementDate] = [];
            }
            if (!events.hasOwnProperty(elementDate)) {
              events[elementDate] = [];
            }

            let color = this.getFieldEventColor(element);
            if (!dayColors[elementDate].includes(color)) {
              dayColors[elementDate].push(color);
            }

            events[elementDate].push(element);
          }
        });
      }

      return {
        events: events,
        dayColors: dayColors,
      };
    },
    dayColors() {
      if (this.eventDateAndDayColors.hasOwnProperty('dayColors')) {
        return this.eventDateAndDayColors.dayColors;
      } else {
        return {};
      }
    },
    eventsDate() {
      if (this.eventDateAndDayColors.hasOwnProperty('events')) {
        return this.eventDateAndDayColors.events;
      } else {
        return {};
      }
    },
    arrayEvents() {
      let events = {};
      // events = {
      //     '2019-02-25': ['primary', 'secundary'],
      //     '2019-02-24': ['success', 'error']
      // }

      // return events;
      if (this.readyToList) {
        this.items.forEach(element => {
          if (this.dateField && element.hasOwnProperty(this.dateField)) {
            let elementDate = moment(element[this.dateField]).format('YYYY-MM-DD');
            if (!events.hasOwnProperty(elementDate)) {
              events[elementDate] = [];
            } else {
              let color = this.getFieldEventColor(element);
              if (!events[elementDate].includes(color)) {
                events[elementDate].push(color);
              }
            }
          }
        });
        return events;
      } else {
        return events;
      }
    },
  },
  methods: {
    getFieldEventColor(field) {
      if (!field.hasOwnProperty(this.eventTypeField)) {
        return this.eventDefaultColor;
      } else if (!this.eventTypeColors.hasOwnProperty(field[this.eventTypeField])) {
        return this.eventDefaultColor;
      } else {
        return this.eventTypeColors[field[this.eventTypeField]];
      }
    },
    clickOnPicker(e) {
      this.$emit('clickOnPicker', e);
    },
  },
  watch: {
    date: function(val, oldVal) {
      this.$emit('input', this.date);
    },
    pickerDate: function(val, oldVal) {
      this.from = moment(this.pickerDate + '-01').format('YYYY-MM-DD');
      this.to = moment(this.from)
        .endOf('month')
        .format('YYYY-MM-DD');
      this.setDateRange(this.from, this.to);
      this.getEntities();
    },
  },
};
</script>

<style lang="scss">
.aru-calendar-list {
  .aru-calendar-list-events {
    .v-list__tile,
    .v-subheader {
      height: 25px;
    }
  }
  .aru-calendar-list-group-activator {
    .v-list__tile {
      height: 30px;
    }
  }
  .v-picker__title {
    color: black;
  }
}
</style>
